import { useState } from 'react'
import AboutMeImg from './AboutMeImg'
import Header from './Header'
import Headlines from './Headline'
import Modal from './Modal'
import AboutMe from '../pages/AboutMe'

export default function Title () {
  const [aboutMe, setAboutMe] = useState(false)

  return (
    <main className='py-[10px] px-[5px]'>
      <section className='flex flex-col justify-center content-center'>
        <Header />
        <section className='
        md:flex
        justify-center
        min-[300px]:grid '
        >
          <AboutMeImg />
          <div className='flex flex-col justify-center'>
            <Headlines />
            <div className='flex flex-nowrap flex-row justify-evenly items-center'>
              {
                aboutMe
                  ? (
                    <Modal>
                      <section className='aboutMeModal'>
                        <AboutMe setAboutMe={setAboutMe} />
                      </section>
                    </Modal>
                    )
                  : null
              }
              <button onClick={() => setAboutMe(true)} className='border-2 border-black rounded-full bg-black text-white p-[5px] px-3'>About</button> &nbsp;
              <section className='flex flex-nowrap flex-col justify-center items-center'>
                <img
                  src={process.env.PUBLIC_URL + 'images/pmp-logo.png'} alt='pmp_icon'
                  className='w-[80px] h-[80px] mt-[20px]'
                />
                <p className='text-center'>PMP Certified</p>
              </section>
            </div>
          </div>
        </section>
      </section>
    </main>
  )
}
